import React, { useEffect, useState } from 'react'
import Layout from '../component/Layout/Layout'
import { Link, useParams } from 'react-router-dom'
import { Form, Modal, Button } from "react-bootstrap";
import parse from "html-react-parser";
import { dateInMDY } from '../Helper'
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSupportTicketConvAPI } from '../hooks/useAllCategoryData';
import { CreateSupportTicketMsgAPI } from '../component/APIS';
import { messageClass } from '../Helper';
export default function SupportTicketView() {
    const queryClient = useQueryClient();
    const [validated, setValidated] = useState(false);
    const [updateMsg, setUpdateMsg] = useState('');

    const { ticketId } = useParams();
    const [currentAdd, setCurrentAdd] = useState({
        support_ticket_id: ticketId,
        message: ''
    });
    const changeHandle = async (event) => {
        const form = event.currentTarget;
        let value = event.target.value;
        let name = event.target.name;
        setCurrentAdd({
            ...currentAdd,
            [name]: value
        })
        //console.log(name,value)
    }
    /* const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }; */

   const editMessageMutation = useMutation({

        mutationFn:CreateSupportTicketMsgAPI,
        onSuccess:()=>{
        queryClient.invalidateQueries({queryKey:['ticketdata']});
        setUpdateMsg('Message Added Successfully!');

        setTimeout(() => {
            setUpdateMsg('');
        }, 1000);

         setCurrentAdd({
            ...currentAdd,
            message:''
        }) 
        setValidated(false);
        }
    }); 

    const handleCreateTicketMsg = async(e)=>{
        const form = e.currentTarget;
        e.preventDefault();
        setValidated(true);
        if(form.checkValidity()===true) {
            //setUpdateMsg('Updateing...');
            editMessageMutation.mutate(currentAdd);
        }
    } 


    const { isLoading, error, data: ticketdata } = useSupportTicketConvAPI(ticketId);
    if (error) return <div>{error.message}</div>;

    //console.log(ticketdata)

    return (
        <Layout title="Support Ticket | Chaashni by Maansi & Ketan">
            <div className="site-content-wrap my-account">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="sustom-heading-h1">Support Ticket <span>Details</span></h1>
                            <div className="content-box">
                                <div className="support-box">
                                
                                    {isLoading && ticketdata?.supportrow.length > 0 && (
                                        <div className='loading-div'><span>Loading...</span></div>
                                    )}
                                    {!isLoading && (
                                        <div className="card ">
                                            
                                            <div className="card-header d-flex justify-content-between align-items-center p-3" style={{ borderTop: '4px solid #e61c44' }}>
                                                <h6 className="mb-0">Subject:  {ticketdata?.supportrow[0].subject}</h6>
                                                <div /*class={messageClass(ticketdata?.supportrow[0].status)}*/>Status: {ticketdata?.supportrow[0].status}</div>
                                               
                                            </div>
                                            <div className="card-body message-box" data-mdb-perfect-scrollbar="true" style={{ position: 'relative', height: 400, overflowY: "auto" }}>
                                                    <div className="d-flex flex-row justify-content-end pt-1">
                                                        <div>
                                                            <p className="msg-box" style={{ backgroundColor: "#d9fdd3" }}>{ticketdata?.supportrow[0].description}</p>
                                                            <p className="msg-date">
                                                                {dateInMDY(ticketdata?.supportrow[0].created_at)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                {!isLoading && ticketdata?.supportdata.length > 0 && (
                                                    <>
                                                        {ticketdata?.supportdata.map((e, i) => (

                                                            <div className={`d-flex flex-row ${e.admin_message ? 'justify-content-start' : 'justify-content-end mb-4 pt-1'}`}>
                                                                <div>
                                                                    <p className="msg-box" style={{ backgroundColor: `${e.admin_message ? 'rgb(236, 236, 236)' : '#d9fdd3'}` }} >{parse(e.admin_message ? e.admin_message : e.customer_message.replace(/(?:\r\n|\r|\n)/g, '<br />'))}</p>
                                                                    <p className="msg-date">{dateInMDY(e.created_at)}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                            {ticketdata?.supportrow[0].status !=='close' ? (

                                            <div className="card-footer text-muted d-flex justify-content-start align-items-center flex-wrap p-3">
                                                                                              
                                                    <Form noValidate validated={validated} onSubmit={handleCreateTicketMsg} className="input-group mb-0 edit-address-form">
                                                        <textarea required type="text" value={currentAdd?.message} onChange={changeHandle} className="form-control" name="message" placeholder="Type message" ></textarea>
                                                        <button className="btn btn-warning" type="submit" id="button-addon2" style={{ paddingTop: '.55rem' }}>
                                                            Submit
                                                        </button>
                                                    </Form>
                                               
                                                {updateMsg !== '' ? (
                                                <p className="text-success text-center">{updateMsg}</p>
                                            ) : ''}
                                            </div>
                                            ):(
                                                <div className="card-footer text-muted d-flex justify-content-center align-items-center flex-wrap p-3 text-center">Ticket has been closed.

                                                </div>    

                                            )}

                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}